import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Id from "../../../../components/Formatters/Id";

const descricaoCell = (description) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{description}</Tooltip>} data-tag="allowRowEvents">
    <Button
      style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "#858796",
        textDecoration: "none",
        padding: 0,
      }}
      variant="link"
      data-tag="allowRowEvents"
    >
      {description}
    </Button>
  </OverlayTrigger>
);

const descricaoCellLeft = (description) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{description}</Tooltip>} data-tag="allowRowEvents">
    <Button
      style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "#858796",
        textDecoration: "none",
        padding: 0,
        textAlign: "left",
      }}
      variant="link"
      data-tag="allowRowEvents"
    >
      {description}
    </Button>
  </OverlayTrigger>
);

const useColumns = () => {
  const columns = [
    {
      name: "Tipo de Ação",
      // selector: "descTipoAcaoFiscal",
      center: true,
      sortable: true,
      cell: (row) => descricaoCell(row.descTipoAcaoFiscal),
      width: "13%",
    },
    {
      name: "Nº OS",
      // selector: "codigo",
      cell: (row) => row.codigo,
      center: true,
      sortable: true,
      width: "9%",
    },
    {
      name: "IE/CNPJ/CPF",
      // selector: "nuInscEstadual",
      cell: (row) => <Id value={row.nuInscEstadual ?? row.nuCnpj ?? row.nuCpf} />,
      center: true,
      width: "15%",
    },
    {
      name: "Razão Social",
      // selector: "contribuinte",
      center: false,
      sortable: true,
      cell: (row) => descricaoCellLeft(row.contribuinte),
      width: "30%",
    },
    {
      name: "Última Atividade Realizada",
      // selector: "ultimaAtividade",
      center: true,
      sortable: true,
      cell: (row) => descricaoCell(row.ultimaAtividade),
    },
  ];

  return columns;
};

export default useColumns;
